import React, { useState } from 'react';
import { Props } from './searchFieldProps';

export const SearchField = ({
    inputPlaceholder,
    labelTitle,
    searchTerm,
    dataListId,
    selectItemId,
    handleResetSearchTerm,
}: Props) => {
    return (
        <div className='mb-4'>
            {labelTitle.trim() !== '' && <label>{labelTitle}:</label>}
            <div
                style={{
                    background: '#fff',
                    position: 'relative',
                }}
            >
                <i
                    className='ri-search-line'
                    style={{
                        position: 'absolute',
                        top: '25%',
                        left: '10px',
                        color: '#9F9FA0',
                    }}
                ></i>
                <input
                    className='form-control text-dark'
                    style={{
                        background: 'transparent',
                        paddingLeft: '25px',
                    }}
                    defaultValue={''}
                    value={searchTerm}
                    list={dataListId}
                    id='exampleDataList'
                    placeholder={inputPlaceholder}
                    onChange={(e) => selectItemId(e)}
                />

                {searchTerm.trim().length > 0 && (
                    <span
                        className='mdi mdi-close-circle search-widget-icon search-widget-icon-close'
                        id='search-close-options'
                        onClick={handleResetSearchTerm}
                        style={{
                            position: 'absolute',
                            right: 30,
                            top: '20%',
                            fontSize: 15,
                            color: '#9F9FA0',
                            cursor: 'pointer',
                        }}
                    ></span>
                )}
            </div>
        </div>
    );
};
